import React from 'react'
import UserContainerComponent from '../../components/usersComponents/UserContainerComponent';

function EnviarData() {
    return (
        <UserContainerComponent>
            <div className='px-4 lg:px-8'>
                <p>Enviar Datos</p>
            </div>
        </UserContainerComponent>
    )
}

export default EnviarData;